import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';
import { Hinzufügen, Export, Endgeräte, Gruppen1, Gruppen2, AiAnalyse2, Mitteilungen, Dashboard } from '../icons';

const Sidebar = ({ className = '' }) => {
  const location = useLocation();
  const isDevicesPage = location.pathname.startsWith('/devices') || location.pathname.startsWith('/device-groups') || location.pathname.startsWith('/add-device') || location.pathname.startsWith('/register-device') || location.pathname.startsWith('/overview-added-devices') || location.pathname.startsWith('/export-data');
  const isNotificationPage = location.pathname.startsWith('/notifications') || location.pathname.startsWith('/alarms') || location.pathname.startsWith('/alarm-rules') || location.pathname.startsWith('/new-alarm-rule');
  const isDashboardPage = location.pathname.startsWith('/dashboards') || location.pathname.startsWith('/dashboard-groups') || location.pathname.startsWith('/dashboard');

  // Content für Endgeräte Sidebar
  const devicesSidebarItems = [
    { label: 'Neues Endgerät hinzufügen', icon: <Hinzufügen />, path: '/add-device'},
    { label: 'Alle Endgeräte', icon: <Endgeräte />, path: '/devices'},
    { label: 'Gruppen', icon: <Gruppen1 />, path: '/device-groups' },
    { label: 'Analyse', icon: <AiAnalyse2 />, path: '#', disabled: true },
    { label: 'Export', icon: <Export />, path: '/export-data' }
  ];

  // Content für Meldungen Sidebar
  const notificationsSidebarItems = [
    { label: 'Neue Alarmregel erstellen', icon: <Hinzufügen />, path: '/new-alarm-rule' },
    { label: 'Alle Alarmregeln', icon: <Mitteilungen />, path: '/alarm-rules' },
    { label: 'Alle ausgelösten Alarme', icon: <Mitteilungen />, path: '/alarms' },
  ];

  // Content für Dashboards Sidebar
  const dashboardsSidebarItems = [
    { label: 'Neues Dashboard erstellen', icon: <Hinzufügen />, path: '/dashboard/new' },
    { label: 'Alle Dashboards', icon: <Dashboard />, path: '/dashboards' },
    { label: 'Gruppen', icon: <Gruppen2 />, path: '/dashboard-groups' },
  ];

  const renderSection = (title, items) => (
    <div className="sidebar-section">
      <h2 className="sidebar-title">{title}</h2>
      <ul className="sidebar-menu">
        {items.map((item, index) => {
          const isActive = !item.disabled && item.path.startsWith('/') && (
            location.pathname.startsWith(item.path) ||
            (item.path === '/add-device' && (location.pathname.startsWith('/register-device-type') || location.pathname.startsWith('/overview-added-devices'))) ||
            (item.path === '/dashboards' && (location.pathname === '/dashboard' || location.pathname.startsWith('/dashboard/view')))
          );
          return (
            <li key={index} className={isActive ? 'active' : ''}>
              {item.disabled ? (
                <button type="button" className="sidebar-item sidebar-item--disabled" disabled aria-disabled="true">
                  <span className="sidebar-icon">{item.icon}</span>
                  <span className="sidebar-label">{item.label}</span>
                </button>
              ) : item.path.startsWith('/') ? (
                <Link to={item.path} className="sidebar-item">
                  <span className="sidebar-icon">{item.icon}</span>
                  <span className="sidebar-label">{item.label}</span>
                </Link>
              ) : (
                <a href={item.path} className="sidebar-item">
                  <span className="sidebar-icon">{item.icon}</span>
                  <span className="sidebar-label">{item.label}</span>
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );

  return (
    <div className={`sidebar ${className}`}>
      {isDevicesPage ? (
        renderSection('Endgeräte', devicesSidebarItems)
      ) : isNotificationPage ? (
        renderSection('Meldungen', notificationsSidebarItems)
       ) : isDashboardPage ? (
        renderSection('Dashboards', dashboardsSidebarItems)
      ) : (
        <ul className="sidebar-main-nav">
          <li className={location.pathname === '/devices' ? 'active' : ''}>
            <Link to="/devices">Geräte</Link>
          </li>
          <li className={location.pathname === '/dashboard' ? 'active' : ''}>
            <Link to="/dashboard">Dashboards</Link>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Sidebar;
